import { ITALIAN_HOLIDAYS } from '../constants';

export const isWeekend = (date: Date) => [0, 6].includes(date.getDay());

export const isHoliday = (date: Date) =>
  ITALIAN_HOLIDAYS.some(
    (holiday) =>
      holiday.day === date.getDate() && holiday.month === date.getMonth(),
  );
